import React from 'react';
// Components
import { styled } from '@mui/material/styles';
import { Link } from '@mui/material';

// Assets
import sigBlkFr from '../../assets/images/sig-blk-fr.svg';
import sigStatsCanBlkEn from '../../assets/images/sig-stats-can-blk-en.svg';

const Root = styled('span')(() => ({
  '& .branding__link': {
    display: 'block',
  },

  '& .branding__image': {
    height: '100%',
    width: '100%',
  },
}));

function BrandingStatCanEn() {
  return (
    <Root>
      <Link
        href="https://www.statcan.gc.ca/en/start"
        className="branding__link"
        underline="hover"
      >
        <img
          src={sigStatsCanBlkEn}
          alt="Statistics Canada"
          className="branding__image"
          loading="lazy"
        />
        <span className="screen-reader-text">
          {' / '}
          <span lang="fr">Statistique Canada</span>
        </span>
      </Link>
    </Root>
  );
}

function BrandingStatCanFr() {
  return (
    <Root>
      <Link
        href="https://www.statcan.gc.ca/fr/debut"
        className="branding__link"
        underline="hover"
      >
        <img
          src={sigBlkFr}
          alt="Statistique Canada"
          className="branding__image"
          loading="lazy"
        />
        <span className="screen-reader-text">
          {' / '}
          <span lang="en">Statistics Canada</span>
        </span>
      </Link>
    </Root>
  );
}

export { BrandingStatCanEn, BrandingStatCanFr };
